export default __webpack_public_path__ + "static/media/elevate-bpn-banner-3.99f89df0.jpg";